import { MenuBookListItem } from 'features/MenuBook/models/menuBook';
import { Fragment, memo } from 'react';
import { Button, Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSort } from 'react-icons/fa';

interface MenuBookListTableProps {
  menuBookList: MenuBookListItem[];
  onSortMenuBook: () => void;
  onSortCourse: () => void;
  onRestoreMenuBook: (menuBookId: number) => void;
  onSelectedRowChanged: () => void;
  onOpenEditMenuBookModal: ({
    menuBookId,
    menuBookName,
    courseId,
    courseName,
  }: {
    menuBookId?: number;
    menuBookName?: string;
    courseId?: number;
    courseName?: string;
  }) => void;
  onRestoreCourse: (courseId: number) => void;
}

function MenuBookListTable({
  menuBookList,
  onSortMenuBook,
  onSortCourse,
  onRestoreMenuBook,
  onSelectedRowChanged,
  onOpenEditMenuBookModal,
  onRestoreCourse,
}: MenuBookListTableProps) {
  const { t } = useTranslation();

  return (
    <div className="sticky-table flex-grow-1 flex-shrink-1">
      <Table hover>
        <thead>
          <tr>
            <th style={{ width: '4%' }}>{t('MenuBookListPage.selection')}</th>
            <th style={{ width: '33%' }}>{t('MenuBookListPage.menu_book')}</th>
            <th className="text-center" style={{ cursor: 'pointer' }} onClick={onSortMenuBook}>
              <div className="text-center d-flex align-items-center justify-content-between">
                <div className="me-3"></div>
                <div>
                  {t('MenuBookListPage.menu_book')}
                  <br />
                  {t('MenuBookListPage.priority_order')}
                </div>
                <div>
                  <FaSort className="fs-2" />
                </div>
              </div>
            </th>
            <th style={{ width: '33%' }}>{t('MenuBookListPage.course')}</th>
            <th className="text-center" style={{ cursor: 'pointer' }} onClick={onSortCourse}>
              <div className="text-center d-flex align-items-center justify-content-between">
                <div className="me-3"></div>
                <div>
                  {t('MenuBookListPage.course')}
                  <br />
                  {t('MenuBookListPage.priority_order')}
                </div>
                <div>
                  <FaSort className="fs-2" />
                </div>
              </div>
            </th>
            <th style={{ width: '10%' }}>{t('MenuBookListPage.edit_menu_book')}</th>
          </tr>
        </thead>
        <tbody>
          {menuBookList.map(function (menuBook) {
            return (
              <Fragment key={`group-menubook-${menuBook.id}`}>
                <tr key={`menubook-${menuBook.id}`} className={menuBook.delete_flg ? 'bg-light' : ''}>
                  <td className="text-center">
                    {menuBook.delete_flg && (
                      <Button className="btn--orange" onClick={onRestoreMenuBook.bind(null, Number(menuBook.id))}>
                        {t('MenuBookListPage.restore')}
                      </Button>
                    )}
                    {!menuBook.delete_flg && (
                      <Form.Check
                        className="chk-menubook-item custom-checkbox"
                        data-type="menubook"
                        data-menubookname={menuBook.name}
                        value={menuBook.id}
                        onChange={onSelectedRowChanged}
                      ></Form.Check>
                    )}
                  </td>
                  <td className="text-center">{menuBook.name}</td>
                  <td className="text-center">{menuBook.priority}</td>
                  <td className="text-center"></td>
                  <td className="text-center"></td>
                  <td className="text-center">
                    {!menuBook.delete_flg && (
                      <Button
                        onClick={onOpenEditMenuBookModal.bind(null, {
                          menuBookId: menuBook.id,
                          menuBookName: menuBook.name,
                        })}
                      >
                        {t('MenuBookListPage.edit')}
                      </Button>
                    )}
                  </td>
                </tr>
                {menuBook.courses.map(function (course) {
                  return (
                    <tr key={`course-${course.id}`} className={course.delete_flg ? 'bg-light' : ''}>
                      <td className="text-center">
                        {course.delete_flg && (
                          <Button className="btn--orange" onClick={onRestoreCourse.bind(null, Number(course.id))}>
                            {t('MenuBookListPage.restore')}
                          </Button>
                        )}
                        {!course.delete_flg && (
                          <Form.Check
                            className="chk-menubook-item custom-checkbox"
                            data-type="course"
                            data-menubookname={menuBook.name}
                            value={`${menuBook.id}-${course.id}`}
                            onChange={onSelectedRowChanged}
                          ></Form.Check>
                        )}
                      </td>
                      <td className="text-center"></td>
                      <td className="text-center"></td>
                      <td className="text-center">{course.name}</td>
                      <td className="text-center">{course.priority}</td>
                      <td className="text-center">
                        {!course.delete_flg && (
                          <Button
                            onClick={onOpenEditMenuBookModal.bind(null, {
                              courseId: course.id,
                              courseName: course.name,
                            })}
                          >
                            {t('MenuBookListPage.edit')}
                          </Button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default memo(MenuBookListTable);
